/* loaded by smart-asset */
export default "https://portfolio.chezvoila.com/iccc/infra/fr/images/tuiles_assemblage.png"